<template>
  <div class="container py-6">
    <div class="custom-logo">
      <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="64" />
      <div>Privacy Policy</div>
    </div>

    <p><strong>Effective Date:</strong> January 1, 2025</p>
    <p>
      At Invoices AI, a product of Jingle Enterprises, we value your privacy and are committed to protecting your personal information. This Privacy
      Policy outlines how we collect, use, and safeguard information when you use our services through
      <a href="https://invoicesai.net" target="_blank">https://invoicesai.net</a> (the “Site”) and the Invoices AI Chrome Extension.
    </p>

    <h3>Information We Collect</h3>
    <p>
      We may collect personal and business-related information such as your name, email, company name, uploaded invoices, and invoice data. This is
      used solely to provide and improve our services.
    </p>

    <h3>How We Use Your Information</h3>
    <ul>
      <li>Analyze scanned invoices and extract structured data</li>
      <li>Populate invoice items into CCC One via our Chrome Extension</li>
      <li>Support and maintain your user account</li>
    </ul>

    <h3>Use of Third-Party Services</h3>
    <p>
      We use trusted vendors for hosting, OCR processing, and storage. These partners are contractually bound to confidentiality and security
      standards.
    </p>

    <h3>Chrome Extension Permissions</h3>
    <p>The extension only interacts with authorized domains and only upon your explicit actions. No unrelated content is accessed.</p>

    <h3>Cookies</h3>
    <p>We use cookies to manage sessions and enhance functionality. Disabling cookies may limit functionality.</p>

    <h3>Data Security</h3>
    <p>We employ industry-standard security practices. However, no system is 100% secure.</p>

    <h3>Data Ownership</h3>
    <p>You retain full ownership of your invoice data. Jingle Enterprises owns the platform, not your data.</p>

    <h3>Disclosure of Information</h3>
    <p>Information may be disclosed if required by law or in defense of legal claims, or upon a business transfer.</p>

    <h3>Changes to This Policy</h3>
    <p>We may update this policy and will post changes on this page.</p>

    <h4>Contact Us</h4>
    <p>
      Jingle Enterprises
      <a href="https://jingleenterprises.com" target="_blank" class="ms-1">(https://jingleenterprises.com)</a>
      <br />
      Email: <a href="mailto:info@jingleenterprises.com">info@jingleenterprises.com</a>
      <br />
      Support: <a href="mailto:info@jingleenterprises.com">support@jingleenterprises.com</a>
    </p>
  </div>
</template>
<style lang="scss" scoped>
.custom-logo {
  width: 100%;
  margin-bottom: 20px;
  display: inline-flex;
  div {
    margin-left: 20px;
    font-size: 2.5rem;
    color: #000;
  }
}
</style>
